import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

const useCarousels = () => {
  const emblaCarousel = document.querySelectorAll('[data-name="carousel"]')

  if (emblaCarousel) {
    emblaCarousel.forEach((node) => {
      const isAutoplay = node.hasAttribute('data-autoplay')
      const delay = node.getAttribute('data-delay')
      const viewport = node.querySelector('[data-name="carousel-viewport"]')
      const controllers = node.querySelector(
        '[data-name="carousel-controllers"]'
      )
      const prev = node.querySelector('[data-name="carousel-prev"]')
      const next = node.querySelector('[data-name="carousel-next"]')
      const dotsContainer = node.querySelector('[data-name="carousel-dots"]')

      const emblaApi = EmblaCarousel(
        viewport,
        {
          align: 'start',
          loop: true
        },
        [
          Autoplay({
            playOnInit: isAutoplay,
            delay: delay || 3000
          })
        ]
      )

      // Dot navigation
      const createDotBtns = () => {
        if (!dotsContainer) return []

        dotsContainer.innerHTML = emblaApi
          .scrollSnapList()
          .map(
            () =>
              '<button class="h-[10px] w-[10px] rounded-full bg-[#FD8661] opacity-50 transition-all" type="button"></button>'
          )
          .join('')

        return Array.from(dotsContainer.querySelectorAll('button'))
      }

      const toggleDotBtnsActive = (dotBtns) => {
        const selectedIndex = emblaApi.selectedScrollSnap()
        dotBtns.forEach((btn, index) => {
          btn.classList.toggle('!opacity-100', index === selectedIndex)
          btn.classList.toggle('!w-[20px]', index === selectedIndex)
        })
      }

      const dotBtns = createDotBtns()

      dotBtns.forEach((btn, index) => {
        btn.addEventListener('click', () => emblaApi.scrollTo(index), false)
      })

      const togglePrevNextBtnsState = () => {
        if (!prev || !next || !controllers) return

        if (emblaApi.canScrollPrev()) prev.removeAttribute('disabled')
        else prev.setAttribute('disabled', 'disabled')

        if (emblaApi.canScrollNext()) next.removeAttribute('disabled')
        else next.setAttribute('disabled', 'disabled')

        controllers.classList[
          !emblaApi.canScrollPrev() && !emblaApi.canScrollNext()
            ? 'add'
            : 'remove'
        ]('hidden')
      }

      emblaApi
        .on('select', () => {
          togglePrevNextBtnsState()
          toggleDotBtnsActive(dotBtns)
        })
        .on('init', () => {
          togglePrevNextBtnsState()
          toggleDotBtnsActive(dotBtns)
        })
        .on('reInit', () => {
          togglePrevNextBtnsState()
          toggleDotBtnsActive(dotBtns)
        })

      if (prev) prev.addEventListener('click', emblaApi.scrollPrev, false)
      if (next) next.addEventListener('click', emblaApi.scrollNext, false)

      // Autoplay controls
      const play = () => {
        const autoplay = emblaApi?.plugins()?.autoplay
        autoplay?.play()
      }

      const stop = () => {
        const autoplay = emblaApi?.plugins()?.autoplay
        autoplay?.stop()
      }

      // Pause on hover
      if (dotsContainer) {
        dotBtns.forEach((btn) => {
          btn.addEventListener('mouseenter', stop, false)
          btn.addEventListener('mouseleave', play, false)
        })
      }
    })
  }
}

export default useCarousels
